var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTektronixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 344.8 62.2",
    style: {
      enableBackground: "new 0 0 344.8 62.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1CB5D8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.8,24.2c0,3.3-2.6,5.9-5.9,5.9c-3.3,0-5.9-2.6-5.9-5.9s2.6-5.9,5.9-5.9 C342.2,18.3,344.8,20.9,344.8,24.2z M333.9,24.2c0,2.8,2.1,5.1,5,5.1s5-2.2,5-5.1c0-2.8-2.1-5.1-5-5.1 C336,19.2,333.9,21.4,333.9,24.2z M337.6,27.6h-0.8v-6.8h2.6c1.5,0,2.2,0.7,2.2,1.9c0,1.2-0.8,1.7-1.7,1.9l2,3h-1l-1.9-3h-1.4 L337.6,27.6L337.6,27.6z M338.7,23.9c1,0,2,0,2-1.2c0-1-0.8-1.2-1.6-1.2h-1.5v2.4L338.7,23.9L338.7,23.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_234_",
    className: "st0",
    d: "M46.7,44.1c0.5,4.5,4.8,7.5,9.7,7.5c4,0,6.2-1.7,7.7-4H77c-2.1,4.7-5,8.4-8.6,10.8 c-3.5,2.5-7.7,3.8-12,3.8C44.3,62.2,34,52.4,34,39.8c0-11.8,9.3-22.7,22.1-22.7c6.5,0,12,2.5,16,6.7C77.4,29.5,79,36.3,78,44 H46.7V44.1z M65.7,34.5c-0.3-2-2.9-6.7-9.4-6.7s-9.1,4.7-9.4,6.7H65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_232_",
    className: "st0",
    d: "M128.1,20.2l12.6-18.6v17h7.8v10.5h-7.8v31.6h-12.6V20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_230_",
    className: "st0",
    d: "M152.4,18.6h11.9v4.7c1.2-2.3,3.4-6.2,10.7-6.2v12.7h-0.5c-6.5,0-9.5,2.4-9.5,8.3v22.7 h-12.6V18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_227_",
    className: "st0",
    d: "M176.6,39.6c0-10.3,7.4-22.4,22.7-22.4c15.4,0,22.7,12.1,22.7,22.4S214.6,62,199.3,62 C183.9,62.1,176.6,50,176.6,39.6L176.6,39.6z M189.2,39.7c0,6.1,4.6,10.6,10.1,10.6s10.1-4.5,10.1-10.6c0-6.2-4.6-10.6-10.1-10.6 C193.8,29,189.2,33.5,189.2,39.7L189.2,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_225_",
    className: "st0",
    d: "M226.1,18.6h11.8v4.5c1.4-2.1,4.1-5.9,11.6-5.9c14.2,0,15.7,11.6,15.7,17.3v26.4h-12.6v-23 c0-4.6-1-8.7-6.6-8.7c-6.2,0-7.2,4.5-7.2,8.8v23h-12.6L226.1,18.6L226.1,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_223_",
    className: "st0",
    d: "M271.1,18.6h12.6v42.2h-12.6V18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_222_",
    className: "st0",
    d: "M277.5,14.4L277.5,14.4c-4,0-7.2-3.2-7.2-7.2l0,0c0-4,3.2-7.2,7.2-7.2l0,0 c4,0,7.2,3.2,7.2,7.2l0,0C284.6,11.2,281.4,14.4,277.5,14.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_220_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_221_",
    className: "st1",
    points: "112.4,16.2 82.2,60.8 95.9,60.8 126.2,16.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_219_",
    className: "st0",
    points: "28.3,13.9 40.8,13.9 49.3,1.2 0,1.2 0,13.9 13.9,13.9 13.9,60.8 28.3,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_218_",
    className: "st0",
    points: "104.4,52.4 108.9,60.8 123.6,60.8 112.6,40.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_217_",
    className: "st0",
    points: "95.4,37.1 95.4,1.2 82.8,1.2 82.8,55.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "330.4,18.6 316.4,18.6 309.1,29.3 301.9,18.6 287.8,18.6 302.1,39.7 287.8,60.8 301.8,60.8  309.1,50 316.4,60.8 330.5,60.8 316.2,39.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTektronixLogo);
export default __webpack_public_path__ + "static/media/tektronix-logo.611d90382fdd13bd3706143074e997b9.svg";
export { ForwardRef as ReactComponent };